import { createSlice } from "@reduxjs/toolkit";
import {
  getContactThunk,
  addOrganizationThunk,
  getIndividualUserThunk,
  getOrganizationsThunk,
  getTagsThunk,
  addTagThunk,
  addContactThunk,
  updateContactThunk,
  updateTagThunk,
} from "./contactThunk";

const initialState = {
  status: "idle",
  status1: "idle",
  status2: "idle",
  error: null,
  success: "",
  getContacts: [],
  getTags: [],
  getOrganizations: [],
  getUserProfile: [],
};

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    resetContactState: () => initialState,

    resetState: (state) => {
      state.status = "idle";
      state.status1 = "idle";
      state.status2 = "idle";
      state.error = null;
      state.success = "";
    },
    setAddNewWaContact: (state, action) => {
      console.log("payLoad", action.payload);

    }
  },
  extraReducers: (builder) => {
    builder
      // 🔹 Get Contacts
      .addCase(getContactThunk.pending, (state) => {
        state.status1 = "loading";
        state.error = null;
      })
      .addCase(getContactThunk.fulfilled, (state, action) => {
        state.status1 = "succeeded";
        state.success = action.payload.success || true;
        state.error = null;
        state.getContacts = action.payload.data || action.payload || [];
      })
      .addCase(getContactThunk.rejected, (state, action) => {
        state.status1 = "failed";
        state.error = action.payload || "Fetching contacts failed";
        state.success = "";
      })

      // 🔹 Get Tags
      .addCase(getTagsThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getTagsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.success = action.payload.success || true;
        state.error = null;
        state.getTags = action.payload.data || action.payload || [];
      })
      .addCase(getTagsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Fetching tags failed";
        state.success = "";
      })

      // 🔹 Add Tag
      .addCase(addTagThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addTagThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.success = action.payload.message || "Tag added successfully";
        state.error = null;
      })
      .addCase(addTagThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to add tag";
        state.success = "";
      })

      // 🔹 Add Contact
      .addCase(addContactThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addContactThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.success = action.payload.message || "Contact added successfully";
        state.error = null;
      })
      .addCase(addContactThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to add contact";
        state.success = "";
      })

      // 🔹 Update Contact
      .addCase(updateContactThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateContactThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.success = action.payload.message || "Contact updated successfully";
        state.error = null;
      })
      .addCase(updateContactThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to update contact";
        state.success = "";
      })

      // 🔹 Update Tag
      .addCase(updateTagThunk.pending, (state) => {
        state.status2 = "loading";
        state.error = null;
      })
      .addCase(updateTagThunk.fulfilled, (state, action) => {
        state.status2 = "succeeded";
        state.success = action.payload.message || "Tag updated successfully";
        state.error = null;
      })
      .addCase(updateTagThunk.rejected, (state, action) => {
        state.status2 = "failed";
        state.error = action.payload || "Failed to update tag";
        state.success = "";
      })

      // 🔹 Add Organization
      .addCase(addOrganizationThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addOrganizationThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.success = action.payload.message || "Organization added successfully";
        state.error = null;
      })
      .addCase(addOrganizationThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to add organization";
        state.success = "";
      })

      // 🔹 Get Organizations
      .addCase(getOrganizationsThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getOrganizationsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.success = action.payload.success || true;
        state.error = null;
        state.getOrganizations = action.payload.data || action.payload || [];
      })
      .addCase(getOrganizationsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Fetching organizations failed";
        state.success = "";
      })

      // 🔹 Get Individual User Profile
      .addCase(getIndividualUserThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getIndividualUserThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.success = action.payload.success || true;
        state.error = null;
        state.getUserProfile = action.payload.data || action.payload || [];
      })
      .addCase(getIndividualUserThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Fetching user profile failed";
        state.success = "";
      });
  },
});

export const { resetContactState, resetState, setAddNewWaContact } = contactsSlice.actions;
export default contactsSlice.reducer;
